
import React from 'react';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ShoppingCart } from 'lucide-react';
import { EcommercePlatform } from '@/components/admin/campaigns/types';

interface EcommercePlatformCardProps {
  platform: {
    id: EcommercePlatform;
    title: string;
    description: string;
    icon: string;
  };
  onSelect: () => void;
}

const EcommercePlatformCard: React.FC<EcommercePlatformCardProps> = ({
  platform,
  onSelect,
}) => {
  // Use a placeholder icon if the image fails to load
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    e.currentTarget.src = '';
    e.currentTarget.style.display = 'none';
    const iconFallback = e.currentTarget.nextElementSibling;
    if (iconFallback) {
      iconFallback.classList.remove('hidden');
    }
  };

  return (
    <Card className="hover:shadow-md transition-shadow">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <img 
              src={platform.icon} 
              alt={platform.title} 
              className="h-8 w-8"
              onError={handleImageError}
            />
            <ShoppingCart className="h-6 w-6 hidden" />
            <CardTitle className="text-lg">{platform.title}</CardTitle>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        <CardDescription className="h-20">
          {platform.description}
        </CardDescription>
      </CardContent>
      <CardFooter>
        <Button onClick={onSelect} className="w-full">
          Select & Configure
        </Button>
      </CardFooter>
    </Card>
  );
};

export default EcommercePlatformCard;
